/**
 * Categoría con restricción de mayoría de edad (18+).
 * Se identifica por slug/nombre para no requerir cambios de schema.
 */
export const AGE_RESTRICTED_CATEGORY_SLUG = "vinos-y-licores";
export const AGE_RESTRICTED_CATEGORY_NAME = "Vinos y Licores";

/** Clave de localStorage que recuerda la verificación de edad en el navegador. */
export const AGE_VERIFIED_STORAGE_KEY = "sucom_age_verified";

/** ¿La categoría dada (por slug o nombre) está restringida a mayores de edad? */
export function isAgeRestrictedCategory(value: string | null | undefined): boolean {
  if (!value) return false;
  const v = value.trim().toLowerCase();
  return (
    v === AGE_RESTRICTED_CATEGORY_SLUG ||
    v === AGE_RESTRICTED_CATEGORY_NAME.toLowerCase()
  );
}
